var React = require('react');

function IconNews2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#000","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M49.414 50.581a3.8 3.8 0 0 1-3.76-2.5V4.201s-.64-3.2-3.76-3.2H3.464s-2.45-.17-2.45 3.2v43.88s-.82 8.71 10.26 8.71h34.2s9.07 1 9.07-7.7v-27.52s-.52-3.33-3.11-3.33h-2.59","key":0}),React.createElement("path",{"fill":"#7BD0E3","fillRule":"nonzero","d":"M5.854 8.361h16.5v16.45h-16.5z","key":1}),React.createElement("path",{"fill":"#7BD0E3","d":"M27.774 34.431h13.07v13.03h-13.07z","key":2}),React.createElement("path",{"d":"M5.854 34.831h15.86M5.854 40.141h15.86M5.854 45.461h15.86M27.594 9.261h12.88M27.594 14.261h12.88M27.594 24.251h12.88M27.594 19.261h12.88","key":3})]));
}

IconNews2.displayName = "IconNews2";

IconNews2.defaultProps = {"width":"56","height":"58"};

module.exports = IconNews2;

IconNews2.default = IconNews2;
